import { ArrowLeft } from "@untitledui/icons/ArrowLeft";
import { useNavigate } from "react-router-dom";

const SKELETON_COUNT = 5;

const ProductSkeleton = ({ levelIcon, pageColor = "purple" }) => {
  const navigation = useNavigate();

  const goBack = () => {
    navigation(-1);
  };

  return (
    <div className={`product-page ${pageColor || ""}`}>
      <div className="container">
        <div className="product-page__head flex flex-align-center flex-between mb-64">
          <div>
            <button className="back-button flex flex-align-center mb-24" onClick={goBack}>
              <ArrowLeft className="mr-8" size={20} />
              Back
            </button>
          </div>
          <img src={levelIcon} alt="" />
        </div>
        <div className="product-page__content">
          <h6 className="mb-24">Pick a topic to get started</h6>
          <ul className="topic-list flex flex-wrap" aria-hidden="true">
            {Array.from({ length: SKELETON_COUNT }, (_, index) => (
              <li key={index} className="topic-card topic-card--skeleton" />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
